export const SENT = "sent";
export const RECEIVED = "received";
export const CALLING_ORIGIN = "calling_origin";
export const CALLING_DESTINATION = "calling_destination";
export const ESTABLISHED = "established";
export const FINISHED = "finished";
export const FAILED = "failed";
export const NOANSWER = "noanswer";
